<div class="border-b">
    <div class="row p-16 cursor-pointer" (click)="openDetail()">
        <div class="col-xs-3 col-sm-2">
            <div class="rat-3-4" *ngIf="countProducts === 1">
                <div class="rat-content">
                    <img *ngIf="image$ | async" class="img-responsive" [src]="image$ | async" alt="" />
                </div>
            </div>

            <div class="multi-img" *ngIf="countProducts > 1">
                <div class="rat-3-4" *ngFor="let image of images$ | async">
                    <div class="rat-content align-center">
                        <img class="img-responsive" [src]="image" />
                    </div>
                </div>
                <div class="rat-3-4" *ngIf="showImageNumber">
                    <div class="rat-content align-center">
                        <div class="title-l-b">+{{ imageNumber }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xs-9 col-sm-10 is-flex flex-column content-sp-between">
            <div class="is-flex flex-column">
                <div class="row">
                    <div class="col">
                        <span class="text-m">{{ order.date | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="col">
                        <formatted-price
                            [price]="order.totalOrder"
                            [options]="{ showAlternateCurrencies: true }"
                            [pricesClasses]="{
                                container: 'is-flex h-100 align-bottom content-end',
                                primaryPrice: 'text-l',
                                alternativeCurrencies: 'text-l'
                            }"
                        ></formatted-price>
                    </div>
                </div>

                <div class="row">
                    <div class="col flex-vcenter">
                        <span class="ttu text-l" *ngIf="countProducts === 1">
                            {{ order.items[0].name }}
                        </span>
                        <span class="ttu text-l" *ngIf="countProducts > 1"> {{ 'dev.item-order.multiple' | translate: { $0: countProducts } }}</span>
                        <div *ngIf="hasSubOrders$ | async" class="has-tooltip-temp pl-8">
                            <svg-icon (mouseenter)="showTooltip = true" src="info"></svg-icon>
                            <info-tooltip
                                *ngIf="showTooltip"
                                class="row cvv-tooltip-right"
                                (closeEvent)="showTooltip = false"
                                [isRepayable]="order.repayable"
                                [subOrdersLength]="order.suborders.length"
                            ></info-tooltip>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="(hideDeliveryDates$ | async) === false">
                    <div *ngIf="!orderCurrentStatus?.delivered && !orderCurrentStatus?.canceled" class="row">
                        <div class="col">
                            <span class="text-m c-dark-grey">
                                {{ 'dev.myAccount.orders.detail.estimatedShipment' | translate }}: {{ deliveryDate$ | async }}
                            </span>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="order.id" class="row">
                    <div class="col">
                        <span class="text-m c-dark-grey">{{ 'dev.myAccount.orders.detail.id' | translate: { $0: order.id } }}</span>
                    </div>
                </div>
                <div *ngIf="order.egui" class="row">
                    <div class="col">
                        <span class="text-m c-dark-grey">{{ order.egui }}</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="is-flex">
                        <span class="order-status mr-8" [ngClass]="'order-status-' + order.status"></span>
                        <span class="is-flex text-l">
                            <ng-container *ngIf="order.phonePurchase"> {{ 'dev.phonePurchase.phonePurchase' | translate }} - </ng-container>
                            {{ currentStatusKey | translate }}
                        </span>
                    </div>
                    <p class="mt-24 text-l is-flex" *ngIf="order.totalPoints">
                        <span>{{
                            'dev.myaccount.mypurchase.pointsEarned'
                                | translate: { $0: (order.totalPoints | formattedNumber: (languageCode$ | async)) }
                        }}</span>

                        <span class="ml-16 points-tooltip is-flex" *ngIf="(orderCurrentStatus?.preparation || isCancelable) && !order.receiptUID">
                            <button type="button" class="btn-tertiary" (click)="togglePointsTooltip($event)">
                                <svg-icon src="question"></svg-icon>
                            </button>
                            <div class="tooltip-sm p-16 tooltip-tr" *ngIf="showPointsTooltip">
                                <button type="button" class="btn-tertiary float-right w-16 ml-8 text-m" (click)="togglePointsTooltip($event)">
                                    <svg-icon src="close-s"></svg-icon>
                                </button>
                                {{ 'dev.myaccount.mypurchase.pointsNotice' | translate }}
                            </div>
                        </span>
                    </p>
                </div>
                <div class="col-auto is-flex align-bottom">
                    <svg-icon *ngIf="showDetail$ | async" src="chevron-down"></svg-icon>
                    <svg-icon *ngIf="(showDetail$ | async) === false" src="chevron-right"></svg-icon>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="showDetail$ | async">
        <div class="row">
            <div class="col">
                <item-order-detail [openedDetail]="openedDetail" [order]="order" [hasSubOrders]="hasSubOrders$ | async"></item-order-detail>
            </div>
        </div>
    </ng-container>
</div>
